export default class AccordionFactory {
  constructor() {
    const accordionItems = document.querySelectorAll(
      '.accordion .accordion__item-header',
    );

    accordionItems.forEach((item) => {
      const root = item.parentElement;
      const content = item.nextElementSibling;

      new Accordion(root, item, content);
    });
  }
}

class Accordion {
  /**
   * @param {Element} root
   * @param {Element} btn
   * @param {Element} content
   */
  constructor(root, btn, content) {
    if (root.classList.contains('is-open')) {
      content.style.maxHeight = `${content.scrollHeight}px`;
    }

    btn.addEventListener('click', () => this.toggle(root, content));
  }

  /**
   * Handles the click on the item-header of an accordion element.
   * @param {Element} root
   * @param {Element} content
   */
  toggle(root, content) {
    if (root.classList.contains('is-open')) {
      root.classList.remove('is-open');
      content.style.maxHeight = 0;
    } else {
      root.classList.toggle('is-open');
      content.style.maxHeight = `${content.scrollHeight}px`;
    }
  }
}
